import React, { useContext, useMemo } from 'react';
import cn from 'classnames';

import VideoElement from './VideoElement';
import MobileSidebar from './MobileSidebar';
import PublisherBtns from '../Components/PublisherBtns';
import { OTContext } from '../../../redux/opentok/context';
import VideoNotifications from '../Components/Notifications';
import Placeholder from '../Components/ActiveSpeaker/Placeholder';
import { useVirtualVisit } from '../../../redux/opentok/hooks/useVirtualVisit';
import styles from './styles.styl';

function MobleVideo() {
  const { state, focusedId, setPin, isProvider, PUBLISHER_KEY } = useContext(
    OTContext,
  );
  const { viewOptions, placeholder } = useVirtualVisit();
  const { collapsed, mobSidebarOpened } = viewOptions;
  const { pinnedId, connections, loading } = state;
  const { publisher, subscribers } = useMemo(() => {
    const { [PUBLISHER_KEY]: pub, ...sub } = connections;
    return { publisher: pub, subscribers: sub };
  }, [connections]);

  const userList = useMemo(() => Object.entries(subscribers), [subscribers]);
  const moreOneUserInRoom = Object.keys(connections).length > 1;

  return (
    <div className={styles.root}>
      <MobileSidebar
        isProvider={isProvider}
        onPin={setPin}
        pinnedId={pinnedId}
        visible={mobSidebarOpened}
        publisher={publisher}
        users={userList}
      />

      <VideoElement connection={publisher} className={styles.me} />
      {userList.map(([id, connection]) => (
        <VideoElement
          className={cn(styles.subscribers, {
            [styles.active]: id === focusedId,
          })}
          connection={connection}
          key={id}
        />
      ))}

      <VideoNotifications />
      {publisher && <PublisherBtns publisher={publisher} disabled={loading} />}
      {!collapsed && !loading && placeholder && !moreOneUserInRoom && (
        <Placeholder {...placeholder} subtitleClassName={styles.mobileMode} />
      )}
    </div>
  );
}

export default MobleVideo;



// WEBPACK FOOTER //
// ./src/components/VirtualVideoRoom/MobileVideo/index.jsx